// @flow

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import styles from './oaManager.scss';
import CreateOaModal from '../../commons/createOaModal/createOaModal';
import ZoomTable from '../../commons/zoomTable/zoomTable';
import DeactivateOaModal from '../../commons/deactivateOaModal/deactivateOaModal';
import { setPageName } from '../../../services/pageService/pageActionCreator';
import TabView from '../../commons/tabView/tabView';
import tabViewList from '../../commons/tabView/tabViewHelper';
import Loader from '../../commons/loader/loader';
import SearchBox from '../../commons/searchBox/searchBox';

import {
  showCreateOaModalAction,
  onCreateOaSubmitAction,
  checkOaMobileExistsAction
} from '../../commons/createOaModal/createOaModalRedux/createOaModalActionCreator';
import {
  showDeactivateOaModalAction,
  deactivateOaAction
} from '../../commons/deactivateOaModal/deactivateOaModalRedux/deactivateOaModalActionCreator';
import {
  getAllData,
  filterTableData
} from './oaManagerRedux/oaManagerActionCreator';
import deactivateOaConfig from '../../commons/deactivateOaModal/deactivateOaHelper';

type Props = {
  oaManagerState: Object,
  createOaModalState: Object,
  deactivateOaModalState: Object,
  onCreateOaSubmitAction: Function,
  showDeactivateOaModal?: boolean,
  showDeactivateOaModalAction: Function,
  deactivateOaAction: Function,
  setPageName: Function,
  showCreateOaModalAction: Function,
  checkOaMobileExistsAction: Function,
  getAllData: Function,
  tabViewList: Array<any>,
  filterTableData: Function
};

type State = {
  oaModal: Object,
  resetSearchText: boolean
};

const pageObj = {
  pageName: 'OA Manager',
  betaPage: false
};

class OaManager extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.componentKey = 'OA_MANAGER';
    this.openDeactivateOaModal = this.openDeactivateOaModal.bind(this);
    this.tableActionFunctions = {
      deactivateOa: this.openDeactivateOaModal
    };

    this.state = {
      oaModal: {},
      resetSearchText: false
    };
  }

  componentDidMount() {
    this.props.setPageName(pageObj);
    // To be updated based on page route params
    this.props.getAllData();
  }

  onSearchValueChange(val) {
    // eslint-disable-next-line
    this.props.filterTableData(val);
  }

  openCreateOaModal() {
    this.props.showCreateOaModalAction(true);
  }

  openDeactivateOaModal(row) {
    this.setState({ oaModal: row }, () => {
      this.props.showDeactivateOaModalAction(true);
    });
  }

  refreshCurrentTab() {
    this.props.getAllData();
    this.setState({
      resetSearchText: true
    });
  }

  modalCloseActionHandler(modalCloseProp) {
    if (modalCloseProp && modalCloseProp.refreshTab) {
      this.refreshCurrentTab();
    }
  }

  render() {
    const {
      isLoading,
      tableData,
      tableDataFiltered
    } = this.props.oaManagerState;
    const tableDataLength = (tableData && tableData.length) || 0;
    return (
      <div className={styles.oaManagerWrapper}>
        <div className={styles.tabContainer}>
          <TabView
            data={this.props.tabViewList}
            selectedTab={0}
            onTabSelect={() => {}}
          />
        </div>
        <div className={` ${styles.utilityBar} l-row a-center`}>
          <div className="flex-60">
            <div
              className={`${styles.btnWrapper} btn-wrapper l-row j-center a-center`}
              onClick={() => this.openCreateOaModal()}
            >
              ADD/EDIT OA
            </div>
          </div>

          <div className="flex-40 l-row j-end">
            <SearchBox
              onSearchValueChange={val => this.onSearchValueChange(val)}
              resetSearchText={this.state.resetSearchText}
              onKeyPress={e => this.onSearchValueChange(e.target.value)}
            />
          </div>
        </div>

        <CreateOaModal
          title="Add/Edit OA"
          createOaModalState={this.props.createOaModalState}
          onCreateOaSubmitAction={this.props.onCreateOaSubmitAction}
          closeCreateOaModalAction={modalCloseProp => {
            this.props.showCreateOaModalAction(false);
            this.modalCloseActionHandler(modalCloseProp);
          }}
          checkOaMobileExistsAction={this.props.checkOaMobileExistsAction}
        />
        <DeactivateOaModal
          deactivateOaModalState={this.props.deactivateOaModalState}
          deactivateOaAction={this.props.deactivateOaAction}
          showDeactivateOaModal={this.props.showDeactivateOaModal}
          title={deactivateOaConfig.title}
          oaModal={this.state.oaModal}
          text={deactivateOaConfig.text}
          closeDeactivateOaModalAction={modalCloseProp => {
            this.props.showDeactivateOaModalAction(false);
            this.modalCloseActionHandler(modalCloseProp);
          }}
        />
        {isLoading ? (
          <Loader />
        ) : (
          <ZoomTable
            configKey={this.componentKey}
            tableDataLength={tableDataLength}
            tableData={tableDataFiltered}
            actionFunctions={this.tableActionFunctions}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  oaManagerState: state.oaManagerState,
  createOaModalState: state.createOaModalState,
  deactivateOaModalState: state.deactivateOaModalState,
  showDeactivateOaModal: state.deactivateOaModalState.showDeactivateOaModal
});

const mapDispatchToProps = dispatch => ({
  setPageName: bindActionCreators(setPageName, dispatch),
  showCreateOaModalAction: bindActionCreators(
    showCreateOaModalAction,
    dispatch
  ),
  onCreateOaSubmitAction: bindActionCreators(onCreateOaSubmitAction, dispatch),
  showDeactivateOaModalAction: bindActionCreators(
    showDeactivateOaModalAction,
    dispatch
  ),
  deactivateOaAction: bindActionCreators(deactivateOaAction, dispatch),
  getAllData: bindActionCreators(getAllData, dispatch),
  filterTableData: bindActionCreators(filterTableData, dispatch),
  checkOaMobileExistsAction: bindActionCreators(
    checkOaMobileExistsAction,
    dispatch
  )
});

OaManager.defaultProps = {
  tabViewList: tabViewList.OA_MANAGER
};

export default connect(mapStateToProps, mapDispatchToProps)(OaManager);
